import {
  Hero,
  CategoryGrid,
  ValidationText,
  SectionHeader,
  ProductGrid,
  ContactCard,
} from "../components";
import { sharedImage, heroImage, categories, products } from "../data";

export default function Home() {
  return (
    <>
      <Hero
        image={heroImage}
        title="Mission Ready"
        subtitle="We build mission-critical packs that are trusted when failure isn't an option."
        cta="Shop Military"
      />
      <CategoryGrid categories={categories} />
      <ValidationText
        title="We Are Expert Pack Makers"
        body="MYSTERY RANCH packs are trusted by those who serve, protect, and take on work that cannot fail. Every detail reflects real mission demands and years of field-proven problem-solving. We build for the mission and for the people who live it every day."
        emphasis="Why? Because we are not just pack makers – we are partners who match the standard you bring to the mission."
      />
      <SectionHeader
        title="Best Sellers"
        subtitle="Mission-driven carry solutions backed by 40+ years of experience."
        action="View All"
      />
      <ProductGrid products={products} />
      <ContactCard
        title="Contact Us"
        subtitle="Warranty Repair Service and Customer Serivce"
      />
      <ContactCard
        title="Find Dealer"
        subtitle="Warranty Repair Service and Customer Serivce"
      />
    </>
  );
}
